import { useTranslation } from "@coworker/locales";
import { DatePicker } from "@coworker/apprestructured/src/shared/components/DatePicker/DatePicker";
import dayjs from "dayjs";
import { useMemo } from "react";

type DailyProps = {
  start: string | null;
  end: string | null;
  startDateError: string | null;
  endDateError: string | null;
  onStartChange: (start: string | null) => void;
  onEndChange: (end: string | null) => void;
};

export const Daily = (props: DailyProps) => {
  const { t } = useTranslation();

  const today = useMemo(() => dayjs().format("YYYY-MM-DD"), []);

  return (
    <>
      <DatePicker
        label={t("startDateString")}
        value={props.start}
        onChange={props.onStartChange}
        errorMessage={props.startDateError}
        min={today}
      />
      <DatePicker
        label={t("endDateString")}
        value={props.end}
        onChange={props.onEndChange}
        errorMessage={props.endDateError}
        min={today}
      />
    </>
  );
};
